import GatewayPUPAdditionalInfoToPurchasePagePolChange from './pages/AdditionalInfoToPurchase/AdditionalInfoToPurchasePagePolChange';

const customerGatewayPolicyChangePUPComponentMap = {
    GatewayPUPAdditionalInfoToPurchasePagePolChange: { component: 'GatewayPUPAdditionalInfoToPurchasePagePolChange' },
};

const customerGatewayPolicyChangePUPComponents = {
    GatewayPUPAdditionalInfoToPurchasePagePolChange
};

export {
    customerGatewayPolicyChangePUPComponentMap,
    customerGatewayPolicyChangePUPComponents
}